module.exports = __webpack_public_path__ + "static/img/1a1ee73.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/txgg_zbfl.png
// module id = 651
// module chunks = 2